import * as $ from "jquery";
import * as _ from "lodash";
import * as moment from "moment-timezone";
import "select2";
import { ModuleCollection } from "../../../../../collections/Modules";
import { TimezoneCollection } from "../../../../../collections/Timezones";
import { Utils } from "../../../../../common/utils";
import { DashboardChannel } from "../../../../../models/DashboardChannel";
import {
    CHART_DATA_RANGE,
    CHART_REAL_TIMESTAMPS,
    DAILY_TIME_MODE
} from "../../../../dashboard/widgets/chart/ChartHelper";
import {
    BaseModifyDashboardWidgetView,
    BaseModifyDashboardWidgetViewOptions,
    NewDashboardChannel
} from "../_BaseModifyWidgetView";

declare var App: any;


export class ModifyTableWidgetView extends BaseModifyDashboardWidgetView {

    private widgetChannels: DashboardChannel[];
    private template = _.template(require('templates/modals/dashboard/modify_widgets/table/table.html'));
    private channelsTemplate = _.template(require('templates/modals/dashboard/modify_widgets/shared/channels.html'));
    private channelFieldTemplate = _.template(require('templates/modals/dashboard/modify_widgets/table/table_channel_field.html'));
    private dateTimePickerFormat = 'MM/DD/YYYY h:mm A';
    private dailyTimeFormat = 'hh:mm A';

    constructor(options: BaseModifyDashboardWidgetViewOptions) {
        super(<any>_.extend({
            tagName: "div",
            className: 'widget-type-chart',
            events: {
                'change .aggregation-period select': 'handleAggregationPeriodChange',
                'change .data-range select': 'handleDataRangeChange',
                'click .add-channel-btn': 'handleAddChannelBtnClick',
                'change .aggregation-wrapper select': 'handleChangeAggregationType',

                'change .custom-labels-config-checkbox': 'handleCustomLabelsToggleChange',

                // Chart Channel Changes
                'change .widget-channel-select-install': 'handleInstallSelectChange',
                'change .widget-channel-select-module': 'handleModuleSelectChange',
                'change .widget-channel-select-channel': 'handleChannelSelectChange',
                'click .widget-channel-delete': 'handleChannelDelete'
            }
        }, options));

        this.widgetChannels = null;
        if (!this.options.widget) {
            this.options.widget = new this.options.dashboardWidgetCollection.model({
                dashboard_id: this.options.dashboardId,
                params: [
                    { key: 'CHART_TITLE', value: '' },
                    { key: 'CHART_TYPE', value: '1' },
                    { key: 'CHART_AGGREGATION_TYPE', value: '1' },
                    { key: 'CHART_AGGREGATION_PERIOD', value: '0' },
                    { key: 'CHART_DATA_RANGE', value: '2' },
                    { key: 'CHART_DATA_ZOOM', value: '2' },
                    { key: 'CHART_TIMEZONE', value: this.options.currentUser.get('timezone') },
                ]
            });
            this.widgetChannels = [];
        } else {
            this.widgetChannels = this.options.dashboardChannelCollection.where({
                dashboard_widget_id: this.options.widget.get('id')
            });
        }

        const rawUseCustomLabelsConfig = this.options.widget.getParamValue('USE_CUSTOM_LABELS', true);
        // coerce the raw value -- which may be a boolean, number, or string -- into a boolean
        this.useCustomLabels = !!Number(rawUseCustomLabelsConfig);
    }

    render() {
        this.$el.html(this.template({
            dashboardCategoriesCollection: this.options.dashboardCategoryCollection,
            widget: this.options.widget,
            c_stacked_bar_hour_url: require('../../../../../../img/widgettypes/table/tablewidgetexample.png'),
            categoryId: this.options.widget.get('dashboard_category_id') ?
                this.options.widget.get('dashboard_category_id') : this.options.categoryId,
            timezones: new TimezoneCollection(),
            currentUser: this.options.currentUser,
            dateTimePickerFormat: this.dateTimePickerFormat,
            dailyTimeFormat: this.dailyTimeFormat,
            moment: moment,
            report: this.options.report,
            isCsv: this.options.report && this.options.report.get('format') === 'csv',
            useCustomLabels: this.useCustomLabels,
        }));

        this.$('select').select2(Utils.Select2.defaultOptions);
        (<any>this.$el.find('input[type="checkbox"]')).bootstrapToggle();

        if (!this.options.widget.isNew()) {
            this.buildInitialChannels();
        } else {
            this.options.parentView.setSavable(false);
            var field = this.renderNewFieldRow();
            this.renderNewChannelRow(field);
            this.delegateEvents();
        }

        this.switchAggPeriod();
        this.handleDataRangeChange();
        this.setUpUIElements();

        return this;
    }

    show() {
        // Refit selects to container width after it is rendered on screen
        (<any>this.$('select')).select2(Utils.Select2.defaultOptions);
        this.initializeCategorySelect('.category select');
    }

    private buildInitialChannels() {
        var widgetId = this.options.widget.get('id');
        var channels = <DashboardChannel[]>this.options.dashboardChannelCollection.where({ dashboard_widget_id: widgetId });
        var aggTypes = this.options.widget.getParamValue('CHART_AGGREGATION_TYPE', '').split(',');
        _.each(_.groupBy(channels, (c: DashboardChannel) => {
            return c.get('dashboard_channel_secondary_order')
        }), (field: any[]) => {
            var fieldRow = this.renderNewFieldRow();
            _.each(field, (c: DashboardChannel) => {
                var installId = c.get('install_id');
                // Use channel's installId, rather than relying on App.getLastSelectedInstallId(), which caused errors
                var row = this.renderNewChannelRow(fieldRow, installId);

                var selectModuleChannel = (row) => {
                    // Select the module
                    row.find('.widget-channel-select-module').val(c.get('module_number')).trigger('change');

                    // Select the channel
                    row.find('.widget-channel-select-channel').val(c.get('channel_id')).trigger('change');
                };

                // Fill in the Dashboard Channel Id
                row.find('.widget-dashboard-channel-id').val(c.get('dashboard_channel_id'));

                // Select the install
                row.find('.widget-channel-select-install').val(installId).trigger('change');
                row.find('.widget-channel-select-channel').data('channelId', c.get('channel_id'));

                var moduleCollectionDeferred = this.options.moduleCollections[installId].getCollectionFetchPromise();
                $.when(moduleCollectionDeferred).done(() => {
                    selectModuleChannel(row);
                });
                if (!this.options.moduleCollections[installId]) {
                    row.hide();
                }

                var aggType = aggTypes[Number(c.get('dashboard_channel_order'))];
                row.find('.widget-channel-select-aggregation-type').val(aggType).trigger('change');
            });
        })

    }

    private setUpUIElements() {
        var toggleButtons = [
            { paramString: 'DAILY_TIME_MODE', className: '.daily-time-mode' },
            { paramString: 'CHART_TIMESTAMPS', className: '.chart-timestamps' },
        ];

        _.each(toggleButtons, (button) => {
            var toggleButton = this.$(<string>button.className + ' input');
            var paramValue: number = Number(this.options.widget.getParamValue(<string>button.paramString, '0'));
            var toggleCondition = paramValue >= 2;

            if (toggleCondition) {
                (<any>toggleButton).bootstrapToggle('off');
            } else {
                (<any>toggleButton).bootstrapToggle('on');
            }
        });

        // Set up date selectors for custom data range
        var from = (<any>this.$('.data-range-custom-from .date'));
        var to = (<any>this.$('.data-range-custom-to .date'));
        // And for custom daily time
        var dailyCustomStart = (<any>this.$('.daily-time-custom-from'));
        var dailyCustomEnd = (<any>this.$('.daily-time-custom-to'));

        from.datetimepicker({
            defaultDate: moment().startOf('day')
        });
        to.datetimepicker({
            defaultDate: moment().endOf('day'),
            useCurrent: false
        });
        from.on("dp.change", function (e) {
            to.data("DateTimePicker").minDate(e.date);
        });
        to.on("dp.change", function (e) {
            from.data("DateTimePicker").maxDate(e.date);
        });

        dailyCustomStart.datetimepicker({
            defaultDate: moment(),
            format: this.dailyTimeFormat
        });
        dailyCustomEnd.datetimepicker({
            defaultDate: moment(),
            format: this.dailyTimeFormat
        });
    }

    private handleChangeAggregationType() {
        this.checkSavable();
    }

    private renderNewFieldRow() {
        var fieldRow = $(<string>this.channelFieldTemplate());
        this.$('.all-channel-fields').append(fieldRow);
        return fieldRow;
    }

    private renderNewChannelRow(field, installId?: number) {
        var newChannelRow = $(<string>this.channelsTemplate({
            organizationCollection: this.options.organizationCollection,
            installCollection: this.options.installCollection,
            lastSelectedInstallId: installId || App.getLastSelectedInstallId(),
            report: this.options.report,
            advancedConfig: this.advancedConfig,
            useCustomLabels: this.useCustomLabels
        }));
        field.children('.channels').append(newChannelRow);

        newChannelRow.find('.widget-channel-select-install').select2(Utils.Select2.defaultOptions);
        newChannelRow.find('.widget-channel-select-module').select2(_.extend({
            disabled: true,
        }, Utils.Select2.defaultOptions));
        newChannelRow.find('.widget-channel-select-channel').select2(_.extend({
            disabled: true,
        }, Utils.Select2.defaultOptions));
        newChannelRow.find('.widget-channel-select-aggregation-type').select2(_.extend({
            disabled: true,
        }, Utils.Select2.defaultOptions));

        // Immediately trigger a change so that preselected installs cause modules to be fetched
        newChannelRow.find('.widget-channel-select-install').trigger('change');
        this.delegateEvents();
        return newChannelRow;
    }

    private handleAddChannelBtnClick(e) {
        e.preventDefault();
        var field = this.$(e.currentTarget).parents('.channel-field');
        this.renderNewChannelRow(field);
        this.switchAggPeriod();
        this.checkSavable();
    }

    private buildModuleOptions(installId) {
        var options = [];
        this.options.moduleCollections[installId].each((module) => {

            // Filter Modules that don't have sensors connected. Control sensors are not
            // Considered sensors in this case
            for (var i = 1; i < 5; i++) {
                var con = module.getConnector(i);
                if (con) {
                    if (con['sensor_type'] === 29) continue;

                    var mod = module.get('module_number');
                    var option = { id: mod, text: module.getDisplayName(), selected: '' };
                    if (mod === App.getLastSelectedModuleNumber()) option.selected = "selected";
                    options.push(option);
                    break;
                }
            }
        });
        if (options.length) return [{ id: '', text: '' }].concat(options);
        return [{ id: '', text: 'No Modules Found' }]
    }

    private handleInstallSelectChange(e: JQuery.UIEventBase) {
        var installSelect = $(e.currentTarget);
        var installId = Number($(installSelect).val());

        if (!installId) return;

        // Save this as the last selected Id on the dashboard
        App.setLastSelectedInstallId(installId);

        var moduleSelect = installSelect.parents('.channel-selects').find('.widget-channel-select-module');
        moduleSelect.empty();

        if (this.options.permissionCollection.canViewInstall(Number(installId))) {
            if (!_.has(this.options.moduleCollections, installId)) {
                this.options.moduleCollections[installId] = new ModuleCollection([], { installId: installId });
                this.options.moduleCollections[installId].fetch();
            }

            if (this.options.moduleCollections[installId].isFetching()) {
                moduleSelect.append('<option value="">Loading...</option>');

                this.options.moduleCollections[installId].once('sync', () => {
                    moduleSelect.empty().select2(_.extend({
                        disabled: false,
                        data: this.buildModuleOptions(installId),
                    }, Utils.Select2.defaultOptions));
                    moduleSelect.trigger('change');
                });
            } else {
                moduleSelect.select2(_.extend({
                    disabled: !installId,
                    data: this.buildModuleOptions(installId),
                }, Utils.Select2.defaultOptions));
            }
        } else {
            moduleSelect.select2(_.extend({
                disabled: !installId,
            }, Utils.Select2.defaultOptions));
        }
        moduleSelect.trigger('change');
        this.checkSavable();
    }

    private handleModuleSelectChange(e: JQuery.UIEventBase) {
        var moduleSelect = $(e.currentTarget);
        var moduleNumber = (<string>$(moduleSelect).val()) || "";
        var channelSelect = $(moduleSelect).parents('.channel-selects').find('.widget-channel-select-channel');
        var installSelect = $(moduleSelect).parents('.channel-selects').find('.widget-channel-select-install');
        var installId = (<string>$(installSelect).val());

        // Save this as the last selected module number on the dashboard
        App.setLastSelectedModuleNumber(moduleNumber);

        channelSelect.empty();
        var channelOptions = [{ id: '', text: '' }];
        if (moduleNumber) {
            var module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
            if (module) {
                _.each([1, 2, 3, 4], (connector) => {
                    var con = module.getConnector(connector);
                    if (con) {
                        var label = 'Connector ' + connector + ': ' + con['sensor_name'];
                        if (!module.showConnector(connector)) label += ' (disconnected)';

                        var optgroup = { text: label, children: [] };
                        _.each(_.sortBy(con.channels, 'channel_position'), (c) => {
                            optgroup.children.push({ id: c['channel_id'], text: c['channel_name'] });
                        });

                        channelOptions.push(<any>optgroup);
                    }
                });
            }
        }
        channelSelect.select2(_.extend({
            disabled: !moduleNumber.length,
            data: channelOptions,
        }, Utils.Select2.defaultOptions));
        channelSelect.trigger('change');
        this.checkSavable();
    }

    private handleChannelSelectChange(e: JQuery.UIEventBase) {
        var channelSelect = $(e.currentTarget);
        var container = $(channelSelect).parents('.channel-selects');
        var moduleSelect = container.find('.widget-channel-select-module');
        var moduleNumber = moduleSelect.val();
        var installSelect = container.find('.widget-channel-select-install');

        var channelNameInput = container.find('.widget-channel-label').val('');
        var channelAggType = container.find('.widget-channel-select-aggregation-type');

        var installId = (<string>$(installSelect).val());
        var channelId = Number(channelSelect.val());

        if (!channelId) {
            channelNameInput.prop('disabled', true);
            channelAggType.prop('disabled', true);
            return;
        }

        var dashbordChannelId = container.find('.widget-dashboard-channel-id').val();
        var module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
        var channel = module.getChannelById(channelId);
        var unit = channel['channel_unit'];
        var unitField = container.find('.thresholds .unit');

        var dashboardChannel = this.options.dashboardChannelCollection.findWhere({
            dashboard_channel_id: Number(dashbordChannelId),
            dashboard_widget_id: this.options.widget.get('id'),
            channel_id: channelId
        });

        if (dashboardChannel) {
            channelNameInput.val(dashboardChannel.get('dashboard_channel_name'));
        }
        if (channelNameInput.val() == '') {
            channelNameInput.val(module.get('module_location') + ' - ' + channel['channel_name']);
        }

        var chartTitleField = $('.chart-title input');
        if (chartTitleField.val() === '') {
            chartTitleField.val(module.get('module_location') + ' - ' + channel['channel_name']);
        }

        channelNameInput.prop('disabled', false);
        channelAggType.prop('disabled', false);

        unitField.val(unit);
        this.checkSavable();
    }

    private handleChannelDelete(e: JQuery.UIEventBase) {
        $(e.currentTarget).parents('.channel-selects').remove();
        this.checkSavable();
    }

    private handleAggregationPeriodChange() {
        this.switchAggPeriod();
        this.checkSavable();
    }

    private handleDataRangeChange() {
        var dataRange = this.$('.data-range select').val();
        this.$('.data-range-custom-wrapper').toggleClass('hidden', dataRange !== CHART_DATA_RANGE.CUSTOM);
        this.$('.daily-time-custom-wrapper').toggleClass('hidden', dataRange !== CHART_DATA_RANGE.CUSTOM_DAILY);
        this.$('.monthly-billing-range-custom-wrapper').toggleClass('hidden', dataRange !== CHART_DATA_RANGE.CUSTOM_MONTHLY_BILLING);
    }

    private switchAggPeriod() {
        var aggBlock = this.$('.aggregation-wrapper');
        if (this.$('.aggregation-period select').val() === '0') {
            aggBlock.css("display", "none");
        } else {
            aggBlock.css("display", "block");
            aggBlock.find('.widget-channel-select-aggregation-type').select2(Utils.Select2.defaultOptions);
        }
    }

    checkSavable() {
        var period = this.$('.aggregation-period select').val();
        var channelsForms = this.$('.channels');
        var savable = _.every(channelsForms, (form) => {
            var eachFieldHasChannel = false;
            var eachHasAgg = true;
            _.each($(form).children('.channel-selects'), (channel) => {
                var channelSelected = $(channel).find('.widget-channel-select-channel').val() !== '';
                eachFieldHasChannel = eachFieldHasChannel ? true : channelSelected;

                if (channelSelected && period !== '0') {
                    eachHasAgg = !eachHasAgg ? false : $(channel).find('.widget-channel-select-aggregation-type').val() !== '';
                }
            });
            return eachFieldHasChannel && eachHasAgg;
        });
        this.options.parentView.setSavable(savable);
    }

    preSave() {
        var aggregationTypesArr = _.map(this.$('.widget-channel-select-aggregation-type'), (type) => {
            return $(type).val();
        });

        this.options.widget.setParamValue('USE_CUSTOM_LABELS', this.useCustomLabels);

        this.options.widget.setParamValue('CHART_TITLE', this.$('.chart-title input').val());
        this.options.widget.setParamValue('CHART_CONNECT_TO_TILES', '2');
        this.options.widget.setParamValue('CHART_AGGREGATION_TYPE', aggregationTypesArr.join(','));
        this.options.widget.setParamValue('CHART_AGGREGATION_PERIOD', this.$('.aggregation-period select').val());
        this.options.widget.setParamValue('CHART_TIMESTAMPS', this.$('.chart-timestamps input').is(':checked')
            ? CHART_REAL_TIMESTAMPS.ENABLED : CHART_REAL_TIMESTAMPS.DISABLED);
        var timezone = String(this.$('.timezone select').val());
        this.options.widget.setParamValue('CHART_TIMEZONE', timezone);
        var dataRange = this.$('.data-range select').val();
        this.options.widget.setParamValue('CHART_DATA_RANGE', dataRange);
        this.options.widget.setParamValue('DAILY_TIME_MODE',
            this.$('.daily-time-mode input').is(':checked')
                ? DAILY_TIME_MODE.FULL_RANGE : DAILY_TIME_MODE.UP_TO_NOW);

        if (dataRange === CHART_DATA_RANGE.CUSTOM) {
            var fromMoment = String(this.$('.data-range-custom-from input').val());
            this.options.widget.setParamValue(
                'CHART_DATA_RANGE_FROM',
                moment.tz(fromMoment, this.dateTimePickerFormat, timezone).unix()
            );

            var toMoment = String(this.$('.data-range-custom-to input').val());
            this.options.widget.setParamValue(
                'CHART_DATA_RANGE_TO',
                moment.tz(toMoment, this.dateTimePickerFormat, timezone).unix()
            );
        } else if (dataRange !== CHART_DATA_RANGE.CUSTOM_MONTHLY_BILLING) {
            // If not custom range, remove custom times
            this.options.widget.setParamValue('CHART_DATA_RANGE_FROM', 0);
            this.options.widget.setParamValue('CHART_DATA_RANGE_TO', 0);
        }

        if (dataRange === CHART_DATA_RANGE.CUSTOM_DAILY) {
            var fromMoment = String(this.$('.daily-time-custom-from input').val());
            this.options.widget.setParamValue(
                'DAILY_TIME_FROM',
                // Get seconds from beginning of the day until the start time
                Math.abs(moment().startOf('day').unix() - moment(fromMoment, this.dailyTimeFormat).unix())
            );

            var toMoment = String(this.$('.daily-time-custom-to input').val());
            this.options.widget.setParamValue(
                'DAILY_TIME_TO',
                // Get seconds from beginning of the day until the end time
                Math.abs(moment().startOf('day').unix() - moment(toMoment, this.dailyTimeFormat).unix())
            );
        } else {
            // If not daily custom range, remove custom times
            this.options.widget.setParamValue('DAILY_TIME_FROM', 0);
            this.options.widget.setParamValue('DAILY_TIME_TO', 0);
        }

        if (dataRange == CHART_DATA_RANGE.CUSTOM_MONTHLY_BILLING) {
            var monthlyBillingDate = String(this.$('.monthly-billing-range-custom-wrapper select').val());
            this.options.widget.setParamValue('CHART_MONTHLY_BILLING_DATE', monthlyBillingDate);
            var monthlyDateTimestamp = moment().startOf('month').add(Number(monthlyBillingDate) - 1, 'day');
            var todaysDate = moment().startOf('day').format('DD');

            var fromMoment: string;
            var toMoment: string;

            if (Number(todaysDate) >= Number(monthlyBillingDate)) {
                // If the billing period ends today or earlier, have the period end the monthly billing date this month
                toMoment = moment(monthlyDateTimestamp).tz(timezone).startOf('day').format(this.dateTimePickerFormat);
                fromMoment = moment(toMoment).tz(timezone).subtract(1, 'month').format(this.dateTimePickerFormat);
            } else {
                // Otherwise, use the last full month's data
                toMoment = moment(monthlyDateTimestamp).tz(timezone).subtract(1, 'month').format(this.dateTimePickerFormat);
                fromMoment = moment(toMoment).tz(timezone).subtract(1, 'month').format(this.dateTimePickerFormat);
            }

            this.options.widget.setParamValue(
                'CHART_DATA_RANGE_FROM',
                moment.tz(fromMoment, this.dateTimePickerFormat, timezone).unix()
            );

            this.options.widget.setParamValue(
                'CHART_DATA_RANGE_TO',
                moment.tz(toMoment, this.dateTimePickerFormat, timezone).unix()
            );

        } else if (dataRange !== CHART_DATA_RANGE.CUSTOM) {
            // If not custom range, remove custom times
            this.options.widget.setParamValue('CHART_DATA_RANGE_FROM', 0);
            this.options.widget.setParamValue('CHART_DATA_RANGE_TO', 0);
        }

        return true;
    }

    public getChannelDifference() {
        var channelsSeen = [];
        var create = [];
        var update = {};
        var fields = this.$('.channel-field');
        var i = 0;
        _.each(fields, (field, j) => {
            var rows = $(field).children('.channels').children('.channel-selects');
            _.each(rows, (row) => {
                var $row = $(row);
                var channelId = $row.find('.widget-channel-select-channel').val();

                var dashboardChannelIdField = $row.find('.widget-dashboard-channel-id');
                var dashboardChannelId = Number(dashboardChannelIdField.val());

                //If the row has no channelId, make sure not to delete it if its a result of not having permissions to view an install
                if (!channelId) {
                    channelId = $row.find('.widget-channel-select-channel').data('channelId');
                    if (channelId) channelsSeen.push(dashboardChannelId);
                    return;
                }
                channelId = Number(channelId);

                // Use default name or custom name based on configuration
                const installSelect = $row.find('.widget-channel-select-install');
                const installId = (<string>$(installSelect).val());
                const moduleNumber = $row.find('.widget-channel-select-module').val();
                const module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
                const channel = module.getChannelById(channelId);
                let name = (<string>$row.find('.widget-channel-label').val()).trim();
                if(!this.useCustomLabels) name = `${module.get('module_location')} - ${channel['channel_name']}`;

                var upsert: NewDashboardChannel = {
                    dashboardId: this.options.dashboardId,
                    widgetId: this.options.widget.get('id'),
                    channelId: <number>channelId,
                    order: i,
                    secondary_order: j,
                    name: name,
                    critLow: <number>null,
                    warnLow: <number>null,
                    warnHigh: <number>null,
                    critHigh: <number>null,
                    rangesList: []
                };
                if (dashboardChannelId) {
                    channelsSeen.push(dashboardChannelId);

                    // Make sure we had permission to update this channel
                    if (!dashboardChannelIdField.attr('data-ignore-update')) update[dashboardChannelId] = upsert;
                } else {
                    create.push(upsert)
                }
                i++;
            });
        });

        var _delete = [];
        _.each(this.widgetChannels, (c) => {
            var dcid = c.get('dashboard_channel_id');
            if (!_.includes(channelsSeen, dcid)) _delete.push(dcid);
        });

        return [create, update, _delete]
    }

    remove() {
        this.stopListening();
        return super.remove();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/dashboard/modify_widgets/table/ModifyTableWidgetView.ts